import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { MenuGroup, MenuItem } from '../../tms-shared/models';
import { MenuService } from '../../tms-shared/services';
import { ApplicationPaths, QueryParameterNames } from '../constants';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private menuService: MenuService,
    private router: Router,
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(
      tap((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          if (state.url === `/${this.authService.homeRoute}`) {
            this.menuService.menus.subscribe((menuGroups: MenuGroup[]) => {
              if (menuGroups.length === 0) {
                this.router.navigateByUrl(ApplicationPaths.Forbidden);
              } else if (this.authService.isCustomer) {
                this.redirectToFirstMenuItem(state);
              }
            });
          } else {
            this.redirectToFirstMenuItem(state);
          }
        } else {
          this.router.navigate(ApplicationPaths.LoginPathComponents, {
            queryParams: {
              [QueryParameterNames.ReturnUrl]: state.url,
            },
          });
        }
      }),
    );
  }

  private redirectToFirstMenuItem(state: RouterStateSnapshot) {
    this.menuService.menuItem(state.url).subscribe((menuItem: MenuItem) => {
      if (!menuItem) {
        this.menuService.menuItems(state.url).subscribe((menuItems: MenuItem[]) => {
          if (menuItems.length > 0) {
            this.router.navigateByUrl(menuItems[0].route);
          } else {
            this.menuService.menus.subscribe((menuGroups: MenuGroup[]) => {
              if (menuGroups.length > 0) {
                this.router.navigateByUrl(menuGroups[0].items[0].route);
              } else {
                this.router.navigateByUrl(ApplicationPaths.Forbidden);
              }
            });
          }
        });
      }
    });
  }
}
